import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, debounceTime } from 'rxjs';
import { PriceCurrencyPipe } from '@/common/pipes/price-currency.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-settlement-bonus-row',
	standalone: true,
	imports: [
		DatePipe,
		FormsModule,
		RouterLink,
		MatCheckboxModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		PriceCurrencyPipe,
	],
	templateUrl: './salary-settlement-bonus-row.component.html',
	styleUrl: './salary-settlement-bonus-row.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalarySettlementBonusRowComponent {
	readonly bonusId = input.required<string>();
	readonly date = input.required<string>();
	readonly name = input.required<string>();
	readonly amountGrosze = input.required<number>();
	readonly currency = input<string | null>(null);
	readonly isSettled = input<string>('0');
	readonly confirmAt = input<string | null>(null);
	readonly bonusComment = input<string | null>(null);
	readonly excluded = input.required<boolean>();
	readonly exclusionComment = input<string | null>(null);
	readonly disabled = input<boolean>(false);

	readonly commentValue = signal<string>('');

	private readonly state = inject(DriversSalaryV2StateService);
	private readonly destroyRef = inject(DestroyRef);
	private readonly commentInput = new Subject<string>();

	constructor() {
		effect(() => this.commentValue.set(this.exclusionComment() ?? ''), { allowSignalWrites: true });

		this.commentInput.pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
			this.state.setBonusExclusion(this.bonusId(), this.excluded(), this.normalize(value));
		});
	}

	onCountedChange(counted: boolean): void {
		this.state.setBonusExclusion(this.bonusId(), !counted, this.normalize(this.commentValue()));
	}

	onCommentInput(value: string): void {
		this.commentValue.set(value);
		this.commentInput.next(value);
	}

	private normalize(value: string): string | null {
		const trimmed = value.trim();
		return trimmed === '' ? null : trimmed;
	}
}
